import { NgModule } from '@angular/core';
import { CanDirective } from './can.directive';

@NgModule({
  declarations: [CanDirective],
  exports: [CanDirective],
})
export class CanModule { }
